import { CheckCircledIcon, CopyIcon } from '@radix-ui/react-icons'
import React, { useRef, useState } from 'react'

import { IconButton, Tooltip } from 'slab'

function CopyButton ({
  valueToCopy,
  variant = 'secondary',
  onClickCallback = () => {},
}: {
  valueToCopy: string;
  variant?: 'default' | 'destructive' | 'primary' | 'secondary';
  onClickCallback?: () => void;
}) {
  const [open, setOpen] = useState(false)
  const [copied, setCopied] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()

    navigator.clipboard.writeText(valueToCopy).then(() => {
      setCopied(true)
    })

    onClickCallback()
  }

  const handleEnter = (e: React.MouseEvent<HTMLButtonElement> | React.FocusEvent<HTMLButtonElement>) => {
    setOpen(true)

    if (e.target === buttonRef.current) {
      setCopied(false)
    }
  }

  const handleLeave = () => {
    setOpen(false)
  }

  return (
    <Tooltip content={copied ? 'Copied!' : 'Copy to clipboard'} open={open}>
      <IconButton
        icon={copied && open ? CheckCircledIcon : CopyIcon}
        label='Copy to clipboard'
        onClick={handleCopy}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        onFocus={handleEnter}
        onBlur={handleLeave}
        ref={buttonRef}
        variant={variant}
      />
    </Tooltip>
  )
}

export default CopyButton
